export default {
  "ConfirmDialog.accept": "Yes",
  "ConfirmDialog.cancel": "No",
};
